import { ref } from "vue";
export default function systemVersion() {
  const appVersion = ref("Version 1.1-RC");
  return { appVersion };
}
